import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as moment from 'moment';
import { STATUS_LIST_VALUE_KEYED, TASK_PRIORITY_KEYED } from '../../../HelperMethods/enums';
import ShouldComponentRender from '../ShouldComponentRender';
import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../../HelperMethods/role-resource-constants';
import { ICON_MAP } from '../../map/constants';
import { CONTAINERS } from '../cardNavigationComponent/cardNavigationRedux';
import styles from './TaskBox.module.css';
import { ReactComponent as EditIcon } from '../../../icons/edit.svg';
import { ReactComponent as CalendarIcon } from '../../../icons/calendar.svg';
import { findTimeForReminder, shouldShowForLoggedInVendor } from '../../../HelperMethods/TaskUtilities';
import { lockIcon } from '../../../HelperMethods/constants';
import CopyComponent from '../CopyComponent';

// eslint-disable-next-line import/no-cycle
import TaskAssignee from '../TaskAssignee';

const formatTimeToHHMMFormat = (date) => {
  return moment(date).format('hh:mm a');
};

const formatTimeToMMDDYYYYFormat = (date) => {
  return moment(date).format('MM/DD/YYYY');
};

const TaskBox = React.memo(({ task, container }) => {
  const assetType = _.get(task, 'asset.type', 'well').toLowerCase();
  const assetName = _.get(task, 'asset.name', 'Asset');
  const taskTypeName = _.get(task, 'taskType.name', 'Task Type');
  const taskNumber = _.get(task, 'taskNumber', '');
  const taskNumberAndName = `${taskNumber ? `${taskNumber} | ` : ''} ${taskTypeName}`;
  const history = useHistory();
  const reminder = findTimeForReminder(task);
  const user = useSelector((state) => state.appReducer.loggedInUser);
  return (
    <div className={styles.taskRow}>
      <div style={{ display: 'flex', fontSize: '12px', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          <div>{formatTimeToHHMMFormat(task.startTime)}</div>
          &nbsp;-&nbsp;
          <div>{formatTimeToHHMMFormat(task.endTime)}</div>
          {reminder ? <div className="reminder-indicator" style={{ marginLeft: '5px', marginTop: '5px' }} /> : null}
          {task.isTaskLocked ? (
            <div style={{ marginTop: '2px' }}>
              <img
                src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(lockIcon)}`}
                className="event-card-lockedTask-icon tooltip-icon"
              />
            </div>
          ) : null}
        </div>
        <div>
          {formatTimeToMMDDYYYYFormat(task.startTime)}&nbsp;&nbsp;
          <CalendarIcon />
        </div>
      </div>
      <div className={styles.taskTypeName}>
        <span title={taskNumberAndName}>
          <CopyComponent textToCopy={taskNumber} floatPosition="left" />
          {taskNumberAndName}
          <ShouldComponentRender
            resourceType={RESOURCE_TYPE.ENTITY}
            resource={RESOURCES.ENTITY.TASK}
            entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
            entity={task}
          >
            &nbsp;&nbsp;&nbsp;
            {shouldShowForLoggedInVendor(task.assigneeIds, user) ? (
              <EditIcon
                style={{ cursor: 'pointer', position: 'relative', top: '4px' }}
                onClick={() => {
                  history.push(`/taskViewPage/task/update/${task.id}`);
                }}
              />
            ) : null}
          </ShouldComponentRender>
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '7px' }}>
        <div className={styles.taskAssetName}>
          <img
            src={ICON_MAP[assetType] || ICON_MAP.well}
            alt={assetType}
            style={{ width: '12px', verticalAlign: 'middle' }}
          />
          &nbsp;&nbsp;{assetName}
        </div>
        <div className={styles.taskPropertyContainer}>
          <div className={styles.taskProperty}>
            <div
              className={styles.taskPropertySymbol}
              style={{ background: TASK_PRIORITY_KEYED[task.priority].backgroundColor }}
            />
            <div className={styles.taskPropertyText}>{TASK_PRIORITY_KEYED[task.priority].text}</div>
          </div>
          <div className={styles.taskProperty}>
            <div
              className={styles.taskPropertySymbol}
              style={{ background: STATUS_LIST_VALUE_KEYED[task.status].color }}
            />
            <div className={styles.taskPropertyText}>{STATUS_LIST_VALUE_KEYED[task.status].text}</div>
          </div>
        </div>
      </div>
      <div className={styles.taskAssigneeName}>
        <TaskAssignee task={task} container={container} />
      </div>
    </div>
  );
});

TaskBox.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired,
    assigneeIds: PropTypes.array.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    taskNumber: PropTypes.string.isRequired,
    assignee: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isTaskLocked: PropTypes.bool,
  }).isRequired,
  container: PropTypes.oneOf(Object.values(CONTAINERS)).isRequired,
};

export default TaskBox;
